/**
 * Auth Module
 */
import Vue from 'vue'
import Nprogress from 'nprogress'
import AuthApi from '@/api/auth'
import router from '../../../router'
import storageUtil from '@/helpers/storage'
import decode from 'jwt-decode'

const state = {
  user: storageUtil.getKey('user', true),
  token: storageUtil.getKey('auth_token')
}

// getters
const getters = {
  getUser: state => state.user,
  getPermissions: state => (state.token ? decode(state.token).permissions.split('|') : []),
  haveRoleId: state => id => {
    if (state.user) {
      return (
        _.findIndex(state.user.roles, o => {
          return o.id === id
        }) > -1
      )
    }
    return false
  },
  haveRoleName: state => name => {
    if (state.user) {
      return (
        _.findIndex(state.user.roles, o => {
          return o.name === name
        }) > -1
      )
    }
    return false
  }
}

// actions
const actions = {  
  activateAccount (context, payload) {
    const { credentials } = payload
    Nprogress.start()
    return new Promise((resolve, reject) => {
      AuthApi.activateAccount(credentials).then(
        data => {
          setTimeout(() => {
            context.commit('activateAccountSuccessfully')
          }, 500)
        },
        error => {
          setTimeout(() => {
            context.commit('activateAccountFailure', error)
            reject(error)
          }, 500)
        }
      )
    })
  },
  createAccount(context, payload){
    const { credentials } = payload
    Nprogress.start()
    return new Promise((resolve, reject) => {
      AuthApi.createAccount(credentials).then(
        data => {
          setTimeout(() => {
            context.commit('createAccountSuccessfully')
          }, 500)
        },
        error => {
          setTimeout(() => {
            context.commit('createAccountFailure', error)
            reject(error)
          }, 500)
        }
      )
    })
  },
  login (context, payload) {    
    const { user } = payload
    Nprogress.start()
    return new Promise((resolve, reject) => {
      AuthApi.login(user).then(
        data => {
          context.commit('loginUserSuccess', data.user)
        },
        error => {
          context.commit('loginUserFailure', error)
          reject(error)
        }
      )
    })
  },
  forgotPassword (context, payload) {
    const { credentials } = payload
    Nprogress.start()
    return new Promise((resolve, reject) => {
      AuthApi.forgotPassword(credentials).then(
        data => {
          setTimeout(() => {
            context.commit('forgotPasswordSuccessfully')
          }, 500)
        },
        error => {
          setTimeout(() => {
            context.commit('forgotPasswordFailure', error)
            reject(error)
          }, 500)
        }
      )
    })
  },
  resetPassword (context, payload) {
    const { credentials } = payload
    Nprogress.start()
    return new Promise((resolve, reject) => {
      AuthApi.resetPassword(credentials).then(
        data => {
          setTimeout(() => {
            context.commit('resetPasswordSuccessfully')
          }, 500)
        },
        error => {
          setTimeout(() => {
            context.commit('resetPasswordFailure', error)
            reject(error)
          }, 500)
        }
      )
    })
  },
  invalidEmail (context) {
    context.commit('invalidEmailSent')
  },
  logout (context) {
    Nprogress.start()
    context.commit('logoutUser')
  },
  user (context) {
    return new Promise((resolve, reject) => {
      AuthApi.user().then(
        data => {
          context.commit('setUser', data)
          resolve()
        },
        error => {
          reject(error)
        }
      )
    })
  },
  setUser (context, payload, token) {
    const { user } = payload
    context.commit('setUser', user)
  }
}

// mutations
const mutations = {
  setUser (state, user, token) {
    state.user = user
    state.token = token
    storageUtil.setKey('user', user)
  },
  activateAccountSuccessfully (state, user) {
    Nprogress.done()    
    router.push({ name: 'login' })
  },
  activateAccountFailure (state, error) {
    Nprogress.done()
    Vue.notify({
      group: 'general',
      type: 'error',
      text: error.message
    })
    return error
  },
  createAccountSuccessfully (state, user) {
    Nprogress.done()
    state.user = user
  },
  createAccountFailure (state, error) {
    Nprogress.done()
    Vue.notify({
      group: 'general',
      type: 'error',
      text: error.message
    })
    return error
  },
  loginUserSuccess (state, user) {
    Nprogress.done()
    state.user = user
    storageUtil.setKey('user', user)
    router.push({ name: 'dashboard' })
  },
  loginUserFailure (state, error) {
    Nprogress.done()
    Vue.notify({
      group: 'general',
      type: 'error',
      text: error.message
    })
    return error
  },
  logoutUser (state) {
    Nprogress.done()
    state.user = null
    storageUtil.removeKey('user')
    storageUtil.removeKey('auth_token')
    router.push({
      name: 'login'
    })
  },
  signUpUserSuccess (state, user) {
    state.user = localStorage.setItem('user', user)
    router.push('/dashboard')
    Vue.notify({
      group: 'general',
      type: 'success',
      text: 'Account Created!'
    })
  },
  signUpUserFailure (state, error) {
    Nprogress.done()
    Vue.notify({
      group: 'general',
      type: 'error',
      text: error.message
    })
  },
  forgotPasswordSuccessfully (state) {
    Nprogress.done()
    router.push({ name: 'login' })
    Vue.notify({
      group: 'general',
      type: 'success',
      text: 'We send you an email to your mailbox!'
    })
  },
  forgotPasswordFailure (state, error) {
    Nprogress.done()
    Vue.notify({
      group: 'general',
      type: 'error',
      text: error.message
    })
  },
  resetPasswordSuccessfully (state) {
    Nprogress.done()

    router.push({ name: 'login' })

    Vue.notify({
      group: 'general',
      type: 'success',
      text: 'You have successfully changed the password'
    })
  },
  resetPasswordFailure (state, error) {
    Nprogress.done()
    Vue.notify({
      group: 'general',
      type: 'error',
      text: error.message
    })
  },
  setPermissions (state, payload) {
    state.user.permisos = payload.permisos
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
